<template lang="pug">
div
  v-card.pa-6.mt-4.round-xl(outlined)
    div.py-6.px-10.round-lg.white(v-if="isFetching")
      v-skeleton-loader(type="list-item-three-line@3")
    template(v-else)
      div.text-md.font-semibold.neutral700--text Automated message for First visit, Second visit, and Reactivation
      div.text-sm.neutral700--text(style="margin-top: 2px;") Automate the process of sending email, SMS or WhatsApp to your loyalty points member
      div.text-md.font-medium.neutral700--text.mt-5 Setup and edit the presets below to your preference.
      v-simple-table.mt-5
        thead
          tr(style="background-color: var(--v-neutral200)")
            th Presets
            th Inventory
            th Reward
            th Status
            th(style="width: 90px;")
        tbody
          template(v-for="(blast, index) in blasts")
            tr(:key="`off-${index}`")
              td.py-3
                div.d-flex.align-center
                  v-avatar.mr-2(size="8" :color="blast.data ? 'success500' : 'blue500'")
                  div.text-sm.font-semibold.neutral700--text.underline.clickable(@click="openDetails(blast)") {{ getText(blast.type) }}
              td.py-3
                template(v-if="blast.data")
                  div.text-xs.neutral700--text(v-if="blast.data.upon_any_purchase") All inventory & services
                  div.text-xs.neutral700--text(v-else) Specific inventory and services ({{ blast.data.purchase_products.length }})
                div.text-xs.neutral500--text(v-else) Not set yet
              td.py-3
                template(v-if="blast.data")
                  div.text-xs.neutral700--text(v-if="blast.data.reward_type === 'discount_percentage'") {{ blast.data.discount_percentage }}% percentage discount
                  div.text-xs.neutral700--text(v-if="blast.data.reward_type === 'discount_amount'") Discount {{ $currency.symbol }} {{ blast.data.discount_amount }}
                  div.text-xs.neutral700--text(v-if="blast.data.reward_type === 'free_item' && blast.data.free_item_type === 'visit'") Free visit
                  div.text-xs.neutral700--text(v-if="blast.data.reward_type === 'free_item' && blast.data.free_item_type === 'other'") Free item: {{ blast.data.free_item_name }}
                  div.text-xs.neutral700--text(v-if="blast.data.reward_type === 'free_item' && blast.data.free_item_type === 'product'") Free inventory & services
                div.text-xs.neutral500--text(v-else) Not set yet
              td.py-3
                template(v-if="blast.data")
                  y-chip(v-if="blast.data.status === 'active'" label="Active" color="green")
                  y-chip(v-if="blast.data.status === 'draft'" label="Draft" color="orange")
                y-chip(v-else label="New" color="blue")
              td.py-3.text-end
                y-button(:label="blast.data ? 'Edit' : 'Set up'" size="sm" outlined :loading="isLoading" @click="openEditSetup(blast)")
      v-divider

  .dialogs
    loyalty-deliverance-details-dialog(v-if="openDeliveranceDetailsDialog" :open.sync="openDeliveranceDetailsDialog" :blast-data="selectedData" @updated="reset" @closed="closed")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LoyaltyDeliveranceDetailsDialog from '@/components/clinic/marketing/dialogs/LoyaltyDeliveranceDetailsDialog.vue'

export default {
  components: { LoyaltyDeliveranceDetailsDialog },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      openDeliveranceDetailsDialog: false,
      selectedData: null,
      blasts: [
        { type: 'first_purchase', data: null },
        { type: 'second_purchase', data: null },
        { type: 'reactivation', data: null }
      ],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      storedOffer: 'marketing/getOffer'
    })
  },
  mounted () {
    this.fetchDeliverance()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchDeliverance () {
      this.isFetching = true
      this.$axios.get(`/loyalty/${this.company.slug}/offers`)
        .then(resp => {
          let blasts = resp.data.results
          if (blasts.find(f => f.type === 'first_purchase')) {
            let data = blasts.find(f => f.type === 'first_purchase')
            let blast = this.blasts.find(f => f.type === 'first_purchase')
            this.$set(blast, 'data', data)
          }
          if (blasts.find(f => f.type === 'second_purchase')) {
            let data = blasts.find(f => f.type === 'second_purchase')
            let blast = this.blasts.find(f => f.type === 'second_purchase')
            this.$set(blast, 'data', data)
          }
          if (blasts.find(f => f.type === 'reactivation')) {
            let data = blasts.find(f => f.type === 'reactivation')
            let blast = this.blasts.find(f => f.type === 'reactivation')
            this.$set(blast, 'data', data)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    openDetails (data) {
      if (!data.data) return
      this.selectedData = data.data
      this.openDeliveranceDetailsDialog = true
    },
    openEditSetup (data) {
      if (!data.data) {
        this.isLoading = true
        let payload = {
          status: 'draft',
          end_after_value: 1,
          end_after_unit: 'months',
          to_all_loyalty_members: true
        }
        if (data.type === 'first_purchase') {
          payload.name = 'First Purchase'
          payload.type = 'first_purchase'
        } else if (data.type === 'second_purchase') {
          payload.name = 'Second Purchase'
          payload.type = 'second_purchase'
        } else if (data.type === 'reactivation') {
          payload.name = 'Reactivation'
          payload.type = 'reactivation'
        }
        this.$axios.post(`/loyalty/${this.company.slug}/offers`, payload)
          .then(resp => {
            this.selectedData = resp.data
            this.openDeliveranceDetailsDialog = true
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
            this.reset()
          })
      } else {
        this.selectedData = data.data
        this.openDeliveranceDetailsDialog = true
      }
    },
    getText (type) {
      if (type === 'first_purchase') return 'First purchase'
      if (type === 'second_purchase') return 'Second purchase'
      if (type === 'reactivation') return 'Reactivation'
    },
    reset () {
      this.fetchDeliverance()
    },
    closed () {
      this.selectedData = null
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  cursor: default;
}
</style>